import React from 'react';
import { translate } from '../../../services/translate';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../../services/central-api/base-service';
import { cameraService } from '../../../services/central-api/cameras';
import AlertModal from '../../../components/AlertModal';

interface SilenceCameraModalProps {
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    isModalVisible: boolean;
    onConfirm: () => void;
    cameraId: string;
}

export default function SilenceCameraModal({ isModalVisible, setModalVisible, onConfirm, cameraId }: SilenceCameraModalProps) {
    async function silenceCamera(): Promise<void | false> {
        try {
            await cameraService.silenceCamera(cameraId);
            setModalVisible(false);
            onConfirm();
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
                return false;
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
            return false;
        }
    }

    return (
        <AlertModal
            description={translate('silenceCameraText')}
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('silence')}
            type='warning'
            onSubmit={silenceCamera}
            customButtonLabel={translate('silence')}
        />
    );
}
